// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import storage from './common/utils/storage'
import {baseUrl, imageBaseUrl } from './config/env'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/iconfont/iconfont.css'
import './assets/iconfont/iconfont'
import * as echarts from 'echarts'
import axios from 'axios'
import Blob from './excel/Blob'
import Sortable from 'sortablejs'
import store from './store'
import Export2Excel from './excel/Export2Excel'

import moment from 'moment'

import { checkPermission } from '@/common/utils/permission.js'
import { Init,getStatus,getErWeiMa,getDocPhoto,BeginTimer,StartSign,StopSign,GetSignImage,CloseDevice } from '@/common/utils/zheLin.js'
import {hiPrintPlugin} from 'vue-plugin-hiprint'

// Vue.use(VuePluginHiPrint);

import VueClipboard from 'vue-clipboard2'
import JsBarcode from 'jsbarcode'

import RFIDServicer from '@/common/utils/RfidServicer.js'
Vue.prototype.$eventBus = new Vue()
let rfidServicer = new RFIDServicer(()=>{

},(data=>{
  Vue.prototype.$eventBus.$emit('pooled6c',data)
  //
}))

Vue.use(VueClipboard)

Vue.use(ElementUI)

import Print from 'vue-print-nb'
Vue.use(Print)
Vue.use(hiPrintPlugin)

// import i18n from './common/i18n'
// Vue.use(ElementUI,{
//   i18n:(key,value) => i18n.t(key,value)
// });   //全部引入   可以根据需求按需引入

Vue.prototype.$storage = storage          //设置全局缓存属性
Vue.prototype.$baseUrl = baseUrl //设置全局图片路径
Vue.prototype.$imageBaseUrl = imageBaseUrl //设置全局图片路径
Vue.prototype.$checkPermission = checkPermission      //全局检验权限方法
Vue.prototype.$echarts = echarts     //设置全局柱状图
Vue.prototype.$http = axios
Vue.prototype.$Sortable = Sortable
Vue.prototype.$JsBarcode = JsBarcode
Vue.prototype.$rfidServicer = rfidServicer

//zheLin高拍设备
Vue.prototype.$Init = Init            //初始化
Vue.prototype.$getStatus = getStatus        //检测设备状态
Vue.prototype.$getErWeiMa = getErWeiMa      //获取条形码信息
Vue.prototype.$getDocPhoto = getDocPhoto      //获取文档照片
Vue.prototype.$BeginTimer = BeginTimer
Vue.prototype.$StartSign = StartSign      //打开签名窗口
Vue.prototype.$StopSign = StopSign        //关闭签名
Vue.prototype.$GetSignImage = GetSignImage      //获取签名图像
Vue.prototype.$CloseDevice = CloseDevice

Vue.prototype.$moment = moment

Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js